import React from 'react';
import { PaperOwnProps, PaperProps } from '@mui/material';
import { BottomDialog, IBottomDialogProps } from 'lib/BottomDialog';
import { useResponsive } from 'src/hooks/useResponsive';
import { BackgroundBlur } from './BackgroundBlur';

interface BaseModalProps extends React.PropsWithChildren<IBottomDialogProps> {
    paperSx?: PaperOwnProps['sx'];
    paperProps?: Omit<PaperProps, 'sx'>;
    noPadding?: boolean;
    scrollable?: boolean;
}

export const BaseModal: React.FC<BaseModalProps> = ({
    paperSx = {},
    paperProps = {},
    noPadding,
    scrollable,
    ...props
}) => {
    const { isDesktop } = useResponsive();

    return (
        <>
            <BackgroundBlur open={props.open} />
            <BottomDialog
                paperProps={{
                    ...paperProps,
                    sx: {
                        borderBottomLeftRadius: isDesktop ? undefined : 0,
                        borderBottomRightRadius: isDesktop ? undefined : 0,
                        borderTopLeftRadius: props.fullScreen ? 0 : undefined,
                        borderTopRightRadius: props.fullScreen ? 0 : undefined,
                        ...(noPadding && { p: 0 }),
                        ...(scrollable && { width: '100%', maxHeight: '100%', overflowY: 'auto' }),
                        ...paperSx
                    }
                }}
                {...props}
            />
        </>
    );
};
